import React, { FC } from "react";
import UniversalTable from "../../organization/table/UniTable";
import { IModules } from "../../../models/IUser";
import { WithModified } from "./utils/modifiedFields";

interface PopupChildModulesTableProps {
  data: WithModified<IModules>[];
  onCellChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    moduleId?: number | null,
    moduleIndex?: number,
  ) => void;
  onAdd?: () => void;
}

export const PopupChildModulesTable: FC<PopupChildModulesTableProps> = ({
  data,
  onCellChange,
  onAdd,
}) => {
  return (
    <div className="popup-child-modules-wrapper">
      <UniversalTable
        data={data}
        type="childModules"
        setOrg={() => {}}
        Edit={() => {}}
        goto={undefined}
        onCellChange={onCellChange}
      />
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          style={{
            marginTop: "8px",
            padding: "4px 12px",
            cursor: "pointer",
            border: "1px solid #1894c3",
            background: "white",
            color: "#1894c3",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        >
          + Добавить СМБ
        </button>
      )}
    </div>
  );
};
